if (!customElements.get('slynara-size-guide')) {
  customElements.define(
    'slynara-size-guide',
    class SlynaraSizeGuide extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-size-guide-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-size-guide-panel]'));
        this.unitButtons = Array.from(this.querySelectorAll('[data-size-guide-unit]'));
        this.unitSwitches = Array.from(this.querySelectorAll('[data-size-guide-switch]'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', this.onTabClick);
          tab.addEventListener('keydown', this.onTabKeydown);
        });
        this.unitButtons.forEach((button) => button.addEventListener('click', this.onUnitChange));
        this.unitSwitches.forEach((button) => button.addEventListener('click', this.onUnitSwitch));
      }

      disconnectedCallback() {
        this.tabs?.forEach((tab) => {
          tab.removeEventListener('click', this.onTabClick);
          tab.removeEventListener('keydown', this.onTabKeydown);
        });
        this.unitButtons?.forEach((button) => button.removeEventListener('click', this.onUnitChange));
        this.unitSwitches?.forEach((button) => button.removeEventListener('click', this.onUnitSwitch));
      }

      selectTab(tab, moveFocus = false) {
        this.tabs.forEach((candidate) => {
          const isSelected = candidate === tab;
          candidate.setAttribute('aria-selected', isSelected.toString());
          candidate.tabIndex = isSelected ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== tab.getAttribute('aria-controls');
        });

        if (moveFocus) tab.focus();
      }

      onTabClick = (event) => {
        this.selectTab(event.currentTarget);
      };

      onTabKeydown = (event) => {
        const currentIndex = this.tabs.indexOf(event.currentTarget);
        let nextIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === undefined) return;

        event.preventDefault();
        this.selectTab(this.tabs[nextIndex], true);
      };

      onUnitChange = (event) => {
        const selectedUnit = event.currentTarget.dataset.sizeGuideUnit;

        this.setUnit(selectedUnit);
      };

      onUnitSwitch = (event) => {
        const selectedUnit = event.currentTarget.getAttribute('aria-checked') === 'true' ? 'cm' : 'in';

        this.setUnit(selectedUnit);
      };

      setUnit(selectedUnit) {

        this.unitButtons.forEach((button) => {
          const isSelected = button.dataset.sizeGuideUnit === selectedUnit;
          button.classList.toggle('is-active', isSelected);
          button.setAttribute('aria-pressed', isSelected.toString());
        });

        this.querySelectorAll('[data-size-guide-value]').forEach((value) => {
          value.hidden = value.dataset.sizeGuideValue !== selectedUnit;
        });

        this.unitSwitches.forEach((button) => {
          const isInches = selectedUnit === 'in';
          button.setAttribute('aria-checked', isInches.toString());
          button.setAttribute('aria-label', `Show measurements in ${isInches ? 'centimetres' : 'inches'}`);
        });

        this.querySelectorAll('[data-size-guide-unit-label]').forEach((label) => {
          label.classList.toggle('is-active', label.dataset.sizeGuideUnitLabel === selectedUnit);
        });
      }
    }
  );
}
